<template>
  <div class="pill__SearchInput InputGroupFocus !w-2/3" v-show="show">
    <input
      class="form-control !py-1"
      type="text"
      :placeholder="$t('Search')"
      v-model="search"
      @keyup.enter.stop.prevent="onEnter"
    />
    <aw-icon 
      icon="search" 
      v-show="!showCloseIcon"
    />
    <button 
      v-show="showCloseIcon"
      @click="eraseSerach()"
      class="SearchInput__CloseIcon"
    >
      <aw-icon icon="close"/>
    </button>
  </div>
</template>

<script>
import HeaderSearchForm from '../../mixins/HeaderSearchForm'

export default {
  mixins: [HeaderSearchForm],
}
</script>

<style lang="scss" scoped></style>
